import { GetWeightString } from '@/components/index/helpers';
import { FormatUtcDate } from '@/helpers/dates';

type IndexInfoItemProps = {
    title: string;
    value: string;
    valueClassName?: string;
};

type IndexInfoListProps = {
    symbol: string;
    weightType: string;
    firstEffectiveAtDate: Date | null;
    numberOfHoldings: number;
};

const IndexInfoItem = ({ title, value, valueClassName }: IndexInfoItemProps) => {
    return (
        <li className="flex justify-between border-b border-brand-gray-med py-2 items-center last-of-type:border-b-0">
            <span className="uppercase">{title}</span>
            <span className={valueClassName}>{value}</span>
        </li>
    );
};

const IndexInfoList = ({ symbol, firstEffectiveAtDate, weightType, numberOfHoldings }: IndexInfoListProps) => {
    return (
        <ul className="w-full text-sm text-brand-gray-darkest">
            <IndexInfoItem
                title="Ticker"
                value={symbol}
                valueClassName="uppercase"
            />
            <IndexInfoItem
                title="Inception Date"
                value={(firstEffectiveAtDate && FormatUtcDate(firstEffectiveAtDate, 'MM/dd/yyyy')) || ''}
            />
            <IndexInfoItem
                title="Weighting"
                value={GetWeightString(weightType)}
            />
            <IndexInfoItem
                title="Number of holdings"
                value={`${numberOfHoldings}`}
            />
        </ul>
    );
};

export default IndexInfoList;
